import React from 'react';
import {
    FaTachometerAlt, FaProjectDiagram,
    FaCommentDots, FaStar, FaEnvelope, FaSignOutAlt, FaPaperPlane,
    FaCheckCircle, FaUserClock, FaTools, FaCalendarPlus, FaRocket,
    FaMoneyBillWave, FaClock, FaUsers, FaHistory, FaPlusCircle, FaUtensils
} from 'react-icons/fa';
import WeatherWidget from '../widgets/WeatherWidget';
import styles from '../../pages/Account.module.css';

const TabOverview = ({
    user, projects, unreadCount, applications, setActiveTab,
    handleLogout, handleMessageSubmit, subject, setSubject,
    message, setMessage, loading, bonuses, allTimeStats
}) => {
    const isVisitor = user?.role === 'user' || user?.profile_type === 'visitor';
    const isCandidate = user?.role === 'candidate';
    const isWorker = user?.role === 'worker' || user?.role === 'foreman';
    const isAdmin = user?.role === 'admin' || user?.role === 'employee' || user?.role === 'bureau';
    const isClient = user?.role === 'client';

    const hasProjects = projects && projects.length > 0;

    // Calculate some quick stats for the overview
    const pendingApplications = applications ? applications.filter(a => a.application_status === 'NOUVEAU').length : 0;

    return (
        <div className={styles.tabContent}>
            <div className={styles.greetingCard}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div>
                        <h2 className={styles.greetingTitle}>
                            Bonjour, {user.name || 'Ami de la Maison'} 👋
                        </h2>
                        <p className={styles.greetingSubtitle}>
                            {isVisitor ? "Votre projet commence ici. Nous sommes ravis de vous accompagner." :
                                isAdmin ? "Tableau de bord de pilotage de la coopérative." :
                                    isWorker ? "Bienvenue sur votre espace artisan. Prêt pour le chantier ?" :
                                        "Voici ce qui se passe dans votre espace aujourd'hui."}
                        </p>
                    </div>
                </div>
            </div>

            {/* VISITOR / ONBOARDING VIEW */}
            {(isVisitor || (!hasProjects && isClient)) && (
                <div className={styles.onboardingCard}>
                    <div className={styles.onboardingTitle}>
                        <FaRocket />
                        <h3>{isCandidate ? "Suivi de votre Candidature" : "Bienvenue parmi nous !"}</h3>
                    </div>
                    <div className={styles.onboardingSteps}>
                        <div className={`${styles.step} ${styles.stepCompleted}`}>
                            <div className={styles.stepIcon}><FaCheckCircle /></div>
                            <span className={styles.stepLabel}>Compte Créé</span>
                        </div>
                        <div className={`${styles.step} ${styles.stepActive}`}>
                            <div className={styles.stepIcon}><FaUserClock /></div>
                            <span className={styles.stepLabel}>Validation en cours</span>
                        </div>
                        <div className={styles.step}>
                            <div className={styles.stepIcon}><FaTools /></div>
                            <span className={styles.stepLabel}>{isCandidate ? "Entretien" : "Activation Espace Client"}</span>
                        </div>
                    </div>
                </div>
            )}

            <div className={styles.overviewGrid}>
                {loading ? (
                    <>
                        <div className={styles.skeleton} style={{ height: '220px', gridColumn: '1 / -1' }}></div>
                        <div className={styles.skeleton} style={{ height: '120px' }}></div>
                        <div className={styles.skeleton} style={{ height: '120px' }}></div>
                        <div className={styles.skeleton} style={{ height: '120px' }}></div>
                    </>
                ) : (
                    <>
                        <div style={{ gridColumn: '1 / -1' }}>
                            <WeatherWidget />
                        </div>

                        {/* PROJECT KPI */}
                        {(isClient || isAdmin) && (
                            <div className={styles.kpiCard} style={{ borderLeft: '4px solid #3b82f6', cursor: 'pointer' }} onClick={() => setActiveTab(isWorker ? 'worksites' : 'projects')}>
                                <div className={styles.kpiIconBox} style={{ background: 'rgba(59, 130, 246, 0.1)', color: '#3b82f6' }}>
                                    <FaProjectDiagram />
                                </div>
                                <div>
                                    <div className={styles.kpiLabel}>Projets Actifs</div>
                                    <div className={styles.kpiValue}>{projects.length}</div>
                                </div>
                            </div>
                        )}


                        {/* SPECIFIC KPIS PER ROLE */}
                        {isWorker && (
                            <>
                                <div className={styles.kpiCard} style={{ borderLeft: '4px solid #8b5cf6', cursor: 'pointer' }} onClick={() => setActiveTab('hours')}>
                                    <div className={styles.kpiIconBox} style={{ background: 'rgba(139, 92, 246, 0.1)', color: '#8b5cf6' }}>
                                        <FaClock />
                                    </div>
                                    <div>
                                        <div className={styles.kpiLabel}>Ce mois-ci</div>
                                        <div className={styles.kpiValue}>{bonuses?.monthlyHours || 0}h</div>
                                    </div>
                                </div>
                                <div className={styles.kpiCard} style={{ borderLeft: '4px solid #3b82f6' }}>
                                    <div className={styles.kpiIconBox} style={{ background: 'rgba(59, 130, 246, 0.1)', color: '#3b82f6' }}>
                                        <FaProjectDiagram />
                                    </div>
                                    <div>
                                        <div className={styles.kpiLabel}>Chantiers impactés</div>
                                        <div className={styles.kpiValue}>{projects.length}</div>
                                    </div>
                                </div>
                            </>
                        )}

                        {isAdmin && (
                            <div className={styles.kpiCard} style={{ borderLeft: '4px solid #f59e0b', cursor: 'pointer' }} onClick={() => setActiveTab('recruitment')}>
                                <div className={styles.kpiIconBox} style={{ background: 'rgba(245, 158, 11, 0.1)', color: '#f59e0b' }}>
                                    <FaUserClock />
                                </div>
                                <div>
                                    <div className={styles.kpiLabel}>Recrutement</div>
                                    <div className={styles.kpiValue}>{pendingApplications > 0 ? `${pendingApplications} nvx` : 'À jour'}</div>
                                </div>
                            </div>
                        )}

                        {/* MESSAGES KPI */}
                        <div className={styles.kpiCard} style={{ borderLeft: '4px solid #f97316', cursor: 'pointer' }} onClick={() => setActiveTab('messages')}>
                            <div className={styles.kpiIconBox} style={{ background: 'rgba(249, 115, 22, 0.1)', color: '#f97316' }}>
                                <FaCommentDots />
                            </div>
                            <div>
                                <div className={styles.kpiLabel}>Ligne Directe</div>
                                <div className={styles.kpiValue}>{unreadCount > 0 ? `${unreadCount} msg` : 'À jour'}</div>
                            </div>
                        </div>

                        {/* WORKER SPECIFIC LIFETIME KPIS */}
                        {isWorker && (
                            <>
                                <div className={styles.kpiCard} style={{ borderLeft: '4px solid #10b981' }}>
                                    <div className={styles.kpiIconBox} style={{ background: 'rgba(16, 185, 129, 0.1)', color: '#10b981' }}>
                                        <FaHistory />
                                    </div>
                                    <div>
                                        <div className={styles.kpiLabel}>Heures de Toujours</div>
                                        <div className={styles.kpiValue}>{allTimeStats?.totalHours || 0}h</div>
                                    </div>
                                </div>
                                <div className={styles.kpiCard} style={{ borderLeft: '4px solid #f59e0b' }}>
                                    <div className={styles.kpiIconBox} style={{ background: 'rgba(245, 158, 11, 0.1)', color: '#f59e0b' }}>
                                        <FaPlusCircle />
                                    </div>
                                    <div>
                                        <div className={styles.kpiLabel}>Total Heures Sup'</div>
                                        <div className={styles.kpiValue}>{allTimeStats?.totalOvertime || 0}h</div>
                                    </div>
                                </div>
                                <div className={styles.kpiCard} style={{ borderLeft: '4px solid #ef4444' }}>
                                    <div className={styles.kpiIconBox} style={{ background: 'rgba(239, 68, 68, 0.1)', color: '#ef4444' }}>
                                        <FaUtensils />
                                    </div>
                                    <div>
                                        <div className={styles.kpiLabel}>Total Paniers</div>
                                        <div className={styles.kpiValue}>{allTimeStats?.totalLunch || 0}</div>
                                    </div>
                                </div>
                                <div className={styles.kpiCard} style={{ borderLeft: '4px solid #64748b' }}>
                                    <div className={styles.kpiIconBox} style={{ background: 'rgba(100, 116, 139, 0.1)', color: '#64748b' }}>
                                        <FaUsers />
                                    </div>
                                    <div>
                                        <div className={styles.kpiLabel}>Ancienneté</div>
                                        <div className={styles.kpiValue}>
                                            {(() => {
                                                const start = new Date(user.created);
                                                const diff = Math.floor((new Date() - start) / (1000 * 60 * 60 * 24));
                                                return diff > 30 ? `${Math.floor(diff / 30)} mois` : `${diff} jours`;
                                            })()}
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                    </>
                )}
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: '25px', marginTop: '10px' }}>
                {/* QUICK ACTIONS */}
                <div className={styles.card} style={{ height: 'fit-content' }}>
                    <h3 className={styles.cardTitle} style={{ marginBottom: '1.5rem', display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <FaStar style={{ color: '#fbbf24' }} /> Accès Rapide
                    </h3>
                    <div className={styles.quickActionGrid}>
                        {(isClient || isWorker || isAdmin) && (
                            <button onClick={() => setActiveTab(isWorker ? 'worksites' : 'projects')} className={styles.quickActionBtn}>
                                <FaProjectDiagram style={{ fontSize: '1.5rem', color: '#3b82f6' }} />
                                <span className={styles.quickActionLabel}>{isWorker ? "Mes Chantiers" : "Mes Projets"}</span>
                            </button>
                        )}

                        {(isWorker || isAdmin) && (
                            <button onClick={() => setActiveTab('expenses')} className={styles.quickActionBtn}>
                                <FaMoneyBillWave style={{ fontSize: '1.5rem', color: '#10b981' }} />
                                <span className={styles.quickActionLabel}>Frais</span>
                            </button>
                        )}


                        {(isWorker || isAdmin) && (
                            <button onClick={() => setActiveTab('planning')} className={styles.quickActionBtn}>
                                <FaCalendarPlus style={{ fontSize: '1.5rem', color: '#8b5cf6' }} />
                                <span className={styles.quickActionLabel}>Planning</span>
                            </button>
                        )}

                        <button onClick={() => setActiveTab('messages')} className={styles.quickActionBtn}>
                            <FaCommentDots style={{ fontSize: '1.5rem', color: '#f59e0b' }} />
                            <span className={styles.quickActionLabel}>Messages</span>
                        </button>

                        {isAdmin && (
                            <button onClick={() => setActiveTab('recruitment')} className={styles.quickActionBtn}>
                                <FaUsers style={{ fontSize: '1.5rem', color: '#3b82f6' }} />
                                <span className={styles.quickActionLabel}>Recrutement</span>
                            </button>
                        )}

                        <button onClick={handleLogout} className={`${styles.quickActionBtn} ${styles.logoutAction}`}>
                            <FaSignOutAlt style={{ fontSize: '1.5rem', color: '#ef4444' }} />
                            <span className={styles.quickActionLabel} style={{ color: '#ef4444' }}>Déconnexion</span>
                        </button>
                    </div>
                </div>

                {/* SUPPORT FORM OR NEXT APPOINTMENT */}
                <div className={styles.card}>
                    <h2 className={styles.cardTitle}><FaEnvelope /> Lancer une demande</h2>
                    <form onSubmit={handleMessageSubmit} className={styles.authForm}>
                        <div className={styles.formGroup}>
                            <label htmlFor="subject">Objet de la demande</label>
                            <input
                                type="text"
                                id="subject"
                                value={subject}
                                onChange={(e) => setSubject(e.target.value)}
                                placeholder="Achat de matériel, question technique..."
                                required
                                style={{ background: '#f8fafc', border: '1px solid #e2e8f0' }}
                            />
                        </div>
                        <div className={styles.formGroup}>
                            <label htmlFor="message">Détails</label>
                            <textarea
                                id="message"
                                value={message}
                                onChange={(e) => setMessage(e.target.value)}
                                rows="4"
                                placeholder="Dites-nous en plus..."
                                required
                                style={{ background: '#f8fafc', border: '1px solid #e2e8f0' }}
                            />
                        </div>
                        <button type="submit" className={styles.submitButton} style={{ background: 'var(--color-primary)', boxShadow: '0 4px 6px -1px rgba(164, 198, 57, 0.4)', color: 'white', width: '100%', justifyContent: 'center' }}>
                            Envoyer maintenant <FaPaperPlane style={{ marginLeft: '8px' }} />
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default TabOverview;
